<template>
  <section>
    <div class="navigation">
      <el-page-header @back="goBack" content="作业详情"></el-page-header>
      <div>
        <el-button v-if="cate == 1" type="primary" icon="el-icon-edit" size="small" @click="editHousework">编辑</el-button>
        <el-button v-if="cate == 1" :disabled="correctData.data2 && correctData.data2.length > 0 ? true : false" plain
          icon="el-icon-delete" size="small" @click="deleteHousework">删除</el-button>
        <el-button v-if="cate == 2 && !detailData.is_do" type="primary" icon="el-icon-edit" size="small"
          @click="feedbackHousework">反馈作业</el-button>
      </div>
      <!-- 编辑作业 -->
      <assign-homework v-if="isShowEdit" :show="isShowEdit" :type="'edit'" :detailData="detailData" @close="close"
        @updateHousework="updateHousework"></assign-homework>
    </div>
    <div class="detail">
      <!-- 左--作业内容 -->
      <el-card shadow="never">
        <div class="title-content">
          <h4>{{ detailData.title }}</h4>
          <span>发表人：{{ userInfo.name }}</span>
          <span>时间：{{ detailData.date }}</span>
        </div>
        <work-content :imgId="'leftImg'" :content="detailData.content" :audio="detailData.voice"
          :isShowAudioPlayer="isShowAudioPlayer" :images="detailData.images" :type="'housework'"></work-content>
      </el-card>
      <!-- 右--批改情况 -->
      <el-card shadow="never" v-if="cate == 1">
        <work-nav @changeTab="changeTab" :number1="correctData.data1.length" :number2="correctData.data2.length"
          :number3="correctData.data3.length" :copyData="correctData.data3"></work-nav>
        <correct-work v-if="workData.length" :tabIndex="tabIndex" :workData="workData"
          :scoreData="detailData.score_data ? detailData.score_data : null"
          @housewoekCorrecting="housewoekCorrecting"></correct-work>

        <!-- 老师批改作业 -->
        <housework-correcting v-if="isShowCorrectDialog" :isShowCorrectDialog="isShowCorrectDialog" :type="correct_type"
          :baseinfo_correcting="baseinfo_correcting" :work_id="work_id" @closeCorrecting="closeCorrecting"
          @updateHousework="updateHousework"></housework-correcting>
      </el-card>
      <el-card v-if="cate == 2" class="feedback-info" shadow="never">
        <div slot="header">
          <h4>反馈情况</h4>
        </div>
        <student-feedback v-if="detailData.feedback" :feedback="detailData.feedback"
          @toEditFeedback="toEditFeedback"></student-feedback>
        <!-- <correct-work v-if="detailData.feedback" :workData="feedback" :span="24"></correct-work> -->
        <el-empty v-else>
          <el-button type="primary" icon="el-icon-edit" size="small" @click="feedbackHousework">反馈作业</el-button>
        </el-empty>

        <!-- 学生反馈作业 -->
        <FeedbackDiolag v-if="isShowFeedbackDialog" :isShowFeedbackDialog="isShowFeedbackDialog"
          :feedback_title="detailData.title" :feedback_content="detailData.content" :type="feedback_type"
          :work_id="work_id" :feedback_data="feedback_type === 'edit_feedback' ? detailData.feedback : null"
          @closeFeedback="closeFeedback" @updateHousework="updateHousework"></FeedbackDiolag>
      </el-card>
    </div>

  </section>
</template>

<script>
import TestAudio from "./components/TestAudio.vue"
import WorkNav from "./components/teacher/WorkNav.vue"
import WorkContent from "./components/WorkContent.vue"
import CorrectWork from "./components/CorrectWork.vue"
import AssignHomework from "./components/list/AssignHomework.vue"
import StudentFeedback from "./components/student/StudentFeedback.vue"
import FeedbackDiolag from "./components/student/FeedbackDiolag.vue"
import HouseworkCorrecting from "./components/teacher/HouseworkCorrecting.vue"
import { mapState } from 'vuex'
export default {
  components: { TestAudio, WorkNav, WorkContent, CorrectWork, AssignHomework, StudentFeedback, FeedbackDiolag, HouseworkCorrecting },
  data () {
    return {
      audio: "", // 音频资源
      isShowAudioPlayer: false, //是否显示音频播放器
      photos: [], //作业详情图片列表
      work_id: "",
      userInfo: {}, // 用户信息
      correctData: {}, //批改相关数据
      detailData: {}, //作业详情全部数据
      workData: [], //作业批改内容
      feedback_detail: {}, //作业反馈内容
      tabIndex: 0,
      isShowEdit: false, //是否显示编辑作业
      cate: localStorage.getItem('cate'),
      isShowFeedbackDialog: false,
      feedback_type: 'feedback', // 反馈类型
      baseinfo_correcting: {}, //批改作业头部信息
      isShowCorrectDialog: false, // 是否显示作业批改弹窗
      correct_type: 'create', //作业批改类型
      correct_id: undefined, //学生反馈的作业id，老师要批改的作业id
      // correct_num:0, // 未批改人数
      // corrected_num:0, // 已批改人数
      // feedback_num:0 // 未反馈人数

    }
  },
  computed: {
    ...mapState({
      classInfo: state => state.classInfo
    }),
  },
  watch: {
    'classInfo.id' (val) {
      this.$router.go(-1)

    }
  },
  mounted () {
    this.work_id = this.$route.query.id
    this.gethomeworkDetail()
    if (this.cate == 2) {
      this.getFeedbackDetail()
    }
  },
  methods: {
    goBack () {
      this.$router.push('/housework')
    },
    // 获取作业详情内容
    async gethomeworkDetail () {
      const { data: res } = await this.$axios.post("/base/homework/detail", {
        work_id: this.work_id,
      })
      const { content, time, user, detail_data, voice } = res.data
      this.detailData = res.data
      this.userInfo = user
      this.correctData = detail_data
      this.isShowAudioPlayer = voice ? true : false
      const index = this.tabIndex
      if (this.cate == 1) {
        // this.workData = detail_data.data1
        this.workData = detail_data['data' + (index + 1)]
      }

    },

    // 获取作业反馈详情
    async getFeedbackDetail () {
      const { data: res } = await this.$axios.post('/base/homework/feedback/detail', { feedback_id: this.correct_id })
      if (res.errCode === 0) {
        // const {user,content} = res.data
        this.baseinfo_correcting = res.data
      } else {
        console.log(res.message)
      }
    },

    changeTab (index) {
      this.tabIndex = index
      switch (index) {
        case 0:
          this.workData = this.correctData.data1
          break
        case 1:
          this.workData = this.correctData.data2
          break
        case 2:
          this.workData = this.correctData.data3
          break
        default:
          break
      }
    },
    // 编辑作业
    editHousework () {
      this.isShowEdit = true
    },
    // 删除作业
    deleteHousework () {
      const work_id = this.$route.query.id
      this.$confirm('您确定要删除该作业?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$axios.post('/base/homework/del', { work_id: work_id })
        if (res.errCode === 0) {
          this.$message.success('删除成功!')
          this.$store.dispatch('setHouseworkStatus', true)
          console.log(this.$store.state.housework_status)
          this.$router.push('/housework')
        } else {
          this.$message.error(res.message)
        }

      })

    },
    close () {
      this.isShowEdit = false
    },
    updateHousework () {
      this.isShowEdit = false
      this.isShowFeedbackDialog = false
      this.isShowCorrectDialog = false
      this.$nextTick(() => {
        this.gethomeworkDetail()
      })

    },
    // 反馈作业
    feedbackHousework () {
      this.feedback_type = 'feedback'
      this.isShowFeedbackDialog = true
    },
    // 编辑反馈作业内容
    toEditFeedback () {
      this.feedback_type = 'edit_feedback'
      this.isShowFeedbackDialog = true
    },
    // 关闭反馈作业弹窗
    closeFeedback () {
      this.isShowFeedbackDialog = false
    },

    // 老师批改作业
    housewoekCorrecting (id, index) {
      this.isShowCorrectDialog = true
      this.correct_id = id
      this.correct_type = index === 0 ? 'create' : 'edit'
      this.getFeedbackDetail()

    },
    closeCorrecting () {
      this.isShowCorrectDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;

  // .el-page-header {
  //   height: 60px;
  //   line-height: 60px;

  //   >>>.el-page-header__left {
  //     color: #2881cd;
  //   }

  //   >>>.el-page-header__content {
  //     font-size: 16px;
  //     color: #1b2422;
  //     font-weight: bold;
  //   }

  //   .el-button.el-button--primary {
  //     height: 32px;
  //   }
  // }
}

.detail {
  display: flex;
  justify-content: space-between;

  // font-family: 'Microsoft' 'YaHei-Regular';
  .el-card {
    border: none;

    h4 {
      margin: 0;
      font-size: 18px;
      line-height: 24px;
    }

    &:nth-child(1) {
      // width: 35%;
      width: 640px;

      .title-content {
        border-bottom: 1px solid #D8E2EB;

        // h4 {
        //   margin: 0;
        //   font-size: 18px;
        //   line-height: 24px;
        // }

        span {
          display: inline-block;
          margin: 10px 0 16px;
          font-size: 14px;
          color: #7C8184;

          &:nth-child(2) {
            margin-right: 40px;
          }
        }
      }

      //   .work-content {
      //     color: #7C8184;
      //     .work-content-img{
      //         margin: 20px 10px 0;
      //         width: 160px;
      //         height: 160px;
      //     }
      //   }

      /deep/ .closeicon {
        display: none;
      }
    }

    &:nth-child(2) {
      width: 976px;
      // padding: 0 20px 0px 0;

      /deep/.work-section {
        display: inline-block;
      }

      /deep/ .el-header {
        height: 70px;
        padding: 0 30px;
        box-sizing: border-box;
        line-height: 70px;
        border-bottom: 1px solid #D8E2EB;
      }

      >>>.el-card__body {
        padding: 0 0 20px 0;
      }


    }

    // 反馈情况
    .feedback-info {
      padding-bottom: 20px;

      .el-empty {
        margin: 30px auto;
      }

      /deep/.work-corrected {
        p {
          width: 530px;
        }

        .audio-player {
          width: 530px;

          .audio-mock-player {
            background: #F5F5F5;
          }

        }
      }
    }
  }
}


// 设置滚动条的样式
/* 设置滚动条的大小 */
.detail .el-card {
  height: 720px;
  overflow: hidden;
  overflow-y: auto;
}

.el-card::-webkit-scrollbar {
  width: 4px;
  /* 纵向滚动条的大小 */
  height: 10px;
  /* 横向滚动条的大小 */
}

/* 设置滚动条可拖动滑块的样式 */
.el-card::-webkit-scrollbar-thumb {

  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px #eee;
  background: #D5DEE5;
}

/* 设置外层轨道的样式 */
.el-card::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px #eee;
  border-radius: 0;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/detail.vue